import * as vp from 'vopay';
import React, { FunctionComponent } from 'react';
import { useLayout } from '../../../../providers/Layout.provider';
import styles from './Error.module.scss';

const { Box, Button, Title, Description } = vp;

type ErrorProps = {
  ErrorMessage: string | React.JSX.Element;
  SecondaryErrorMessage: string | React.JSX.Element;
  ErrorButtonText: string;
  OtherButtonText?: string;
  TryAgain: () => void;
  Other?: () => void;
};

type FC = FunctionComponent<ErrorProps>;

const Error: FC = (props: ErrorProps) => {
  const { ErrorMessage, SecondaryErrorMessage, ErrorButtonText, OtherButtonText, TryAgain, Other } = props;
  const { color } = useLayout();

  return (
    <Box flx="col" gapSize="24px" width="100%" ai="center">
      <Box flx="col" width="100%" height="auto">
        <Title size="lg" bold title={ErrorMessage} />
      </Box>
      {SecondaryErrorMessage && (
        <Box flx="col" width="100%" height="auto">
          <Description color="#949494" align="center" size="smmd" hasNoPadding>
            {SecondaryErrorMessage}
          </Description>
        </Box>
      )}
      <Box flx="col" width="360px" jc="center" gapSize="24px">
        <Box height="auto" width="100%">
          <Button
            id="login"
            label={ErrorButtonText}
            type="submit"
            background={color}
            textColor={vp.getContrastColor(color)}
            width="100%"
            size="xlg"
            round
            bold
            noShadow
            textSize={1}
            onClick={() => {
              TryAgain();
            }}
          />
        </Box>
        {Other && (
          <>
            <div className={styles.lineContainer}>
              <span>OR</span>
            </div>
            <Box height="auto" width="100%">
              <Button
                id="login"
                label={OtherButtonText || ''}
                type="submit"
                color="#ffffff"
                width="100%"
                size="xlg"
                round
                bold
                textSize={1}
                onClick={() => {
                  Other();
                }}
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Error;
